/**
 * 句对齐模块共用的数据
 * @author: Mengyu Jin
 * @since: 2022-10-19 11:32:31
 */
export default {
  state: {
    name: "-",
  },
  mutations: {
    setAlignmentTaskName(state, data) {
      state.name = data;
    },
  },
  actions: {
    setAlignmentTaskName({ commit }, data) {
      commit("setAlignmentTaskName", data);
    },
  },
  getters: {
    alignmentTaskName(state) {
      return state.name;
    },
  },
};
